module.exports = __webpack_public_path__ + "img/alergia.e1d9f71d.png";